import React, { useEffect, useState } from 'react';

import { useSelector } from '@datagrid/state';

import { BackendClient, GraphQLClient, requestIdHeader } from '@tf/api';
import { useGetAuthToken } from '@tf/shared';
import { Box, Modal, TFText } from '@tf/ui';

import { configStore } from '@/core/stores';
import { ModalFooter } from '@/components/shared';

interface Props {
	definitionsRevision: string;
}

export const BackendClientInitialization: React.FC<Props> = ({ definitionsRevision }) => {
	const config = useSelector(() => configStore.get());

	const getAuthToken = useGetAuthToken();

	const [isModalOpened, setModalOpened] = useState(false);

	useEffect(() => {
		const fetchWithStatusCheck = async (input: RequestInfo | URL, init?: RequestInit) => {
			const token = await getAuthToken();
			const response = await fetch(input, {
				...init,
				headers: {
					...init?.headers,
					...requestIdHeader(),
					Authorization: `Bearer ${token}`,
					'Configuration-Revision': definitionsRevision,
				},
			});

			if (response.status === 409) {
				setModalOpened(true);
			}

			return response;
		};

		BackendClient.init(config.urls.backend, fetchWithStatusCheck);

		GraphQLClient.init(`${config.urls.api}/graphql`, getAuthToken);
	}, [config.urls.backend, config.urls.api, definitionsRevision, getAuthToken]);

	const onReload = async () => {
		window.location.reload();
	};

	return (
		<Modal title="App is oudated" opened={isModalOpened} withCloseButton={false} onClose={() => {}}>
			<Box px="1rem" py="0.75rem">
				<TFText>Please reload page to get new version</TFText>
			</Box>

			<ModalFooter submitText="Reload" onSubmit={onReload} />
		</Modal>
	);
};
